import { blogDeleteFun } from '../../../api/addDataAPI';
import errorHandle from '../../../utils/errorHandle';

export default async function deleteBlogsData(blogData, setLoading) {
    setLoading(true);
    try {
        const res = await blogDeleteFun(blogData);
        if (res.status === 200) {
            return res.status;
        }
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}
